import { render } from "./BaseCheckBoxV2.vue?vue&type=template&id=d9c398f6"
import script from "./BaseCheckBoxV2.vue?vue&type=script&lang=js"
export * from "./BaseCheckBoxV2.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__